import React from 'react';

// Routes
import Routes from './enquiries-all-routes';

export default function (props) {

  return (
   <div>
       <Routes />
   </div>
  )
}
